import { FormControlLabel, Switch } from "@mui/material";
import { GraphOperatorFieldWrapper, SelectEl } from "../style/GraphOperator.styled";

const viewSize = [5, 10, 20, 30];

export default function GraphOperatorFieldView({
    checkedExcludedDeliveryChargeSwitch,
    onChangeExcludedDeliveryChargeSwitch
}) {
    return (
        <GraphOperatorFieldWrapper>
            <div className='toggle-group'>
                <FormControlLabel labelPlacement="start" control={<Switch checked={checkedExcludedDeliveryChargeSwitch} onChange={() => onChangeExcludedDeliveryChargeSwitch()} />} label="배송비 미포함" />
            </div>
        </GraphOperatorFieldWrapper>
    )
}